import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { Link, useNavigate } from "react-router-dom";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Tab, Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { useSelector } from "react-redux";
import useAxiosFile from "../../actions/useaxios";
import config from "../../actions/config";
import noimg from "../../assets/images/dummy.png";
import { EncryptData } from "../../actions/common";

function ShopList() {
  const { toggle, payload, token } = useSelector(
    (state) => state.seller_panel.User
  );

  const axiosFile = useAxiosFile();

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
    onSizePerPageChange: function (page, sizePerPage) {
      console.log("page", page);
      console.log("sizePerPage", sizePerPage);
    },
  });
  const columns = [
    {
      dataField: "",
      text: "SNO",
      formatter: (cell, row, rowIndex) => <>{rowIndex + 1}</>,
    },
    { dataField: "BrandName", text: "Brand Name", sort: false },
    {
      dataField: "BrandImage",
      text: "Brand Image",
      sort: false,
      formatter: (cell, row) => (
        <img
          className="tab_dummyimg"
          src={cell ? `${config.shopimg}/${cell}` : noimg}
          alt='dummyimg'
        />
      ),
    },
    { dataField: "BrandDescription", text: "Description", sort: false },
    {
      dataField: "Category",
      text: "Category",
      sort: false,
      formatter: (cell, row) => <>{cell?.Categoryname}</>,
    },
    {
      dataField: "",
      text: "Status",
      formatter: (cell, row) => <>{console.log('celllllll', row)}{row?.deleted ? "DeActivated" : "Active"}</>,
    },
    {
      dataField: "",
      text: "Edit",
      formatter: (cell, row) => (
        // <button className="table_grnavtivebtn" onClick={()=>navigate(`/addaccount/${EncryptData(row._id)}`)}>
        <button className="table_grnavtivebtn" onClick={() => nav(row)}>
          <span>Edit</span>
          {/* </button> */}
        </button>
      ),
    },
    {
      dataField: "_id",
      text: "FAQ",
      formatter: (cell, row) => (
        // <button className="table_grnavtivebtn" onClick={()=>navigate(`/addaccount/${EncryptData(row._id)}`)}>
        <div onClick={() => navigate(`/store-faq/${(cell)}`)}>
          <p>Open FAQ</p>
        </div>
      ),
    },

  ];

  /** lp */

  const [shoplist, SetShopList] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    console.log("Dsadasdasdasdasdsadas", payload?._id, token);
    if (payload?._id) GetShoplist();
  }, [payload?._id, token]);

  const GetShoplist = async () => {
    let Resp = await axiosFile.getshop({
      SellerId: payload?._id,
      from: "seller",
    });
    console.log("dfjkdjfhkdlshfd", Resp);
    SetShopList(Resp?.data);
  };

  const nav = (row) => {
    console.log("DsjdadlkJLJL13132", EncryptData(row._id));
    navigate(`/addaccount/?Id=${EncryptData(row._id)}`);
  };
  /** lp */
  return (
    <section id="content-wrapper">
      <div class="row">
        <div className="top_title_sec">
          <div>
            <p className="page_title">Shops</p>
          </div>

          {/* <div className="rightside">
                        <div className='order_calendar_div'>
                              <p className={opacity == "true" ? "hiding_caltxt" : ""}>Start Date</p>
                              <img className='order_calendar_ic' src={require('../../assets/images/icons/calendar.png')}/>
                              <Datetime onChange={()=>{setOpacity("true")}} className='order_datepick'/>
                            </div>

                            <p className='order_totxt'>To</p>
                            <div className='order_calendar_div'>
                              <p className={opacityEnd == "true" ? "hiding_calendtxt" : ""}>End Date</p>
                              <img className='order_calendar_ic' src={require('../../assets/images/icons/calendar.png')}/>
                              <Datetime onChange={()=>{setEndOpacity("true")}} className='order_datepick'/>
                            </div>
                        </div> */}
        </div>
        <button
          type="button"
          className="blue_btn add_deliveryprsn"
          onClick={() => navigate("/addaccount")}
        >
          Add Shop
        </button>
      </div>
      <div className="row mt-4">
        <div className="sec_border">
          <div className="row">
            {/* <div className="col-xxl-4 col-xl-4 col-lg-3 col-md-3 col-sm-12 col-12">
                            <div className="whole_searchbar white_bg">
                              
                              <input placeholder="Search term" />
                            </div>
                          </div> */}
            {console.log("kjshjfkdshkjgds", shoplist)}
            <div className="orders_tabs">
              <Row>
                <Col sm={12}>
                  {shoplist && (
                    <div className="ffd_table row">
                      <BootstrapTable
                        bootstrap4
                        keyField="id"
                        columns={columns}
                        data={shoplist}
                        options={{
                          onExportToCSV: shoplist,
                        }}
                        exportCSV
                        pagination={pagination}
                        noDataIndication="No Shops found"
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ShopList;
